import { css } from '@emotion/core';

export const scrollbarHoverRevealStyle = {
    '& .ScrollbarsCustom-Track': {
        opacity: '0 !important'
    },

    '&.ScrollbarsCustom': {
        '&:hover': {
            '& .ScrollbarsCustom-Track': {
                opacity: '1 !important'
            }
        }
    },
    '& .ScrollbarsCustom-Wrapper': {
        bottom: '0 !important'
    }
};

export const hiddenScrollbarStyle = css`
    overflow-y: auto;
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;
